module.exports = __webpack_public_path__ + "img/708.bed51156.jpg";